export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6742.c3763880.jpg";